import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import InputMask from 'react-input-mask';

class BaseSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      name: null,
      variable_parameter_bkp: 0,
      variable_parameter_quantity: 0,
      maks_name: null,
      group_name: null,
      group_type: null,
      group_hour_start: null,
      group_hour_finish: null,
      group_turn: null,
      params: [],
      base_setting: {},
      base_setting_groups: {},
      base_setting_groups_select: [],
      roles: [],
      roles_headers: [],
      base_id: this.props.base_id,
      base_setting_id: this.props.base_setting_id,
    };

    //bind específico
    this.edit = this.edit.bind(this);
    this.addGroup = this.addGroup.bind(this);
    this.deleteGroup = this.deleteGroup.bind(this);
    this.markChecked = this.markChecked.bind(this);
    this.markHc = this.markHc.bind(this);
    this.editParameter = this.editParameter.bind(this);
    this.deleteBaseSettingRoleDelete = this.deleteBaseSettingRoleDelete.bind(this);
  }
  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && typeof newProps.base_setting.name !== 'undefined') {
      this.setState({
        base_setting: newProps.base_setting,
        name: newProps.base_setting.name,
        maks_name: newProps.base_setting.name,
        roles_headers: newProps.base_setting.roles_headers,
        base_setting_id: newProps.base_setting.id,
        base_setting_groups: newProps.base_setting.base_setting_groups,
        params: newProps.base_setting.params,
        base_setting_groups_select: newProps.base_setting.base_setting_groups_select,
        roles: newProps.roles,
      });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    var self = this;
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.base_setting_id,
      name: this.state.maks_name,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/base/mascara', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addGroup(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      base_setting_id: this.state.base_setting_id,
      base_id: this.state.base_id,
      name: this.state.group_name,
      type: this.state.group_type,
      hour_start: this.state.group_hour_start,
      hour_finish: this.state.group_hour_finish,
      turn: this.state.group_turn,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/base/mascara/grupo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteGroup(base_setting_group_id) {
    var confirm = window.confirm('Tem certeza que deseja deletar esse grupo?');
    if (confirm) {
      var self = this;
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/base/mascara/grupo/' + base_setting_group_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  markChecked(base_setting_id) {
    var confirm = window.confirm('Tem certeza que deseja marcar esta máscara como padrão de escala?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: base_setting_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/base/mascara/marcar/padrao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  markHc(base_setting_id) {
    var confirm = window.confirm('Tem certeza que deseja marcar esta máscara como padrão de HC?');
    if (confirm) {
      var datasave = {
        id: base_setting_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/base/mascara/marcar/hc', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  editParameter(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      base_setting_id: this.state.base_setting_id,
      base_id: this.state.base_id,
      role_id: this.state.role_id,
      group_id: this.state.group_id,
      size: this.state.size,
      variable_parameter_quantity: this.state.variable_parameter_quantity,
      variable_parameter_bkp: this.state.variable_parameter_bkp,
      fixed_parameter_quantity: this.state.quantity_fixed,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/base/grupo/parametros', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteBaseSettingRoleDelete(id) {
    if (window.confirm('Tem certeza que deseja deletar esse parâmetro?')) {
      var self = this;
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/base/parametro', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div className="card">
    <div className="card-grey">
      <h4 className="pull-left">{self.state.name}</h4>
      {(self.state.base_setting.hc === 1) ?
        <button disabled className="btn btn-sequential btn-warning pull-right" title="Marcar como HC"><i className="fa fa-fw fa-calendar"></i></button>
        :
        <button className="btn btn-sequential btn-warning pull-right" title="Marcar como HC" onClick={() => {self.markHc(self.state.base_setting.id)}}><i className="fa fa-fw fa-calendar"></i></button>
      }
      {(self.state.base_setting.default === 1) ?
        <button disabled className="btn btn-sequential btn-success pull-right" title="Marcar como padrão"><i className="fa fa-fw fa-check"></i></button>
        :
        <button className="btn btn-sequential btn-success pull-right" title="Marcar como padrão" onClick={() => {self.markChecked(self.state.base_setting.id)}}><i className="fa fa-fw fa-check"></i></button>
      }
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Máscara:</label>
            <input type="text" className="form-control" name="maks_name" value={this.state.maks_name} onChange={this.handleChange.bind(this, 'maks_name')} />
          </div>
          <div className="col-md-6 form-group">
            <button type={'submit'} className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Editar máscara</button>
          </div>
        </div>
      </form>
      <hr/>
      <form onSubmit={this.addGroup}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Grupo:</label>
            <input type="text" className="form-control" name="group_name" value={this.state.group_name} onChange={this.handleChange.bind(this, 'group_name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Tipo:</label>
            <Select
              className="form-field-name"
              name="group_type"
              value={this.state.group_type}
              searchable={true}
              placeholder={'Selecionar tipo'}
              onChange={this.handleSelectChange.bind(this, 'group_type')}
              options={[
                {value: 1, label: 'Quinzenal'},
                {value: 3, label: 'Semanal'},
                {value: 2, label: 'Comercial'},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Hora inicial:</label>
            <InputMask value={this.state.group_hour_start}  maskChar={null} name="group_hour_start" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'group_hour_start')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Hora final:</label>
            <InputMask value={this.state.group_hour_finish}  maskChar={null} name="group_hour_finish" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'group_hour_finish')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Turno:</label>
            <Select
              className="form-field-name"
              name="group_turn"
              value={this.state.group_turn}
              searchable={true}
              placeholder={'Selecionar turno'}
              onChange={this.handleSelectChange.bind(this, 'group_turn')}
              options={[
                {value: 1, label: 'Diurno'},
                {value: 2, label: 'Noturno'},
              ]}
            />
          </div>
          <div className="col-md-6 form-group">
            <button type={'submit'} className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Adicionar grupo</button>
          </div>
        </div>
      </form>
      <hr/>
      <h4>Grupos da base</h4>
      <hr/>
      <table className="table table-stripped table-hover table-bordered">
        <thead>
          <tr>
            <th>Nome do grupo</th>
            <th>Hora inicial</th>
            <th>Hora final</th>
            <th>Tipo</th>
            <th>Turno</th>
            <th className="col-md-1 text-center"></th>
          </tr>
        </thead>
        <tbody>
        {Object.keys(self.state.base_setting_groups).map(function(k) {
          var group = self.state.base_setting_groups[k];
          return (
            <tr>
              <td>{group.name}</td>
              <td>{group.hour_start}</td>
              <td>{group.hour_finish}</td>
              <td>{group.type}</td>
              <td>{group.turn}</td>
              <td><button className="btn btn-sm btn-danger" onClick={() => {self.deleteGroup(group.id)}}><i className="fa fa-fw fa-trash"></i></button></td>
            </tr>
          );
        })}
        </tbody>
      </table>
    </div>
    <div className="card-default">
      <div className="row">
        <div className="col-md-12">
          <form onSubmit={this.editParameter}>
            <h4>Adicionar parâmetros</h4>
            <hr/>
            <div className="row">
              <div className="col-md-4 form-group">
                <label>Função:</label>
                <Select
                  className="form-field-name"
                  name="role_id"
                  value={this.state.role_id}
                  searchable={true}
                  placeholder={'Selecionar função'}
                  onChange={this.handleSelectChange.bind(this, 'role_id')}
                  options={this.state.roles}
                  required
                />
              </div>
              <div className="col-md-4 form-group">
                <label>Grupo:</label>
                <Select
                  className="form-field-name"
                  name="group_id"
                  value={this.state.group_id}
                  searchable={true}
                  placeholder={'Selecionar grupo'}
                  onChange={this.handleSelectChange.bind(this, 'group_id')}
                  options={this.state.base_setting_groups_select}
                  required
                />
              </div>
              <div className="col-md-4 form-group">
                <label>Porte:</label>
                <Select
                  required
                  className="form-field-name"
                  name="size"
                  value={this.state.size}
                  searchable={true}
                  placeholder={'Selecionar porte'}
                  onChange={this.handleSelectChange.bind(this, 'size')}
                  options={[
                    {value: "PP", label: "PP"},
                    {value: "MP", label: "MP"},
                    {value: "GP", label: "GP"},
                    {value: "SMP", label: "SMP"},
                    {value: "AVI", label: "AVI"},
                  ]}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 form-group">
                  <label>Quantidade fixa:</label>
                  <input type="text" className="form-control" name="quantity_fixed" value={self.state.quantity_fixed} onChange={self.handleChange.bind(self, 'quantity_fixed')} />
              </div>
              <div className="col-md-4 form-group">
                <label>Quantidade variável(Nº AVN EM OPERAÇÃO x {this.state.variable_parameter_quantity}): <i className="fa fa-question-circle" data-toggle="tooltip" data-placement="top" title="" data-original-title="Preencher com a razão Função/ANV em numeros. Ex.: Se a razão for de 1 para cada 2 aeronaves, o valor a ser preenchido é 0.5 (1/2). Sendo 1 para cada 3 aeronaves, o valor a ser preencido é 0.33 (1/3)." aria-describedby="tooltip153469"></i></label>
                <input type="text" className="form-control" name="variable_parameter_quantity" value={this.state.variable_parameter_quantity} onChange={this.handleChange.bind(this, 'variable_parameter_quantity')}
                 />
              </div>
              <div className="col-md-4 form-group">
                <label>Considerar aeronave backup como operacional <i className="fa fa-question-circle" data-toggle="tooltip" data-placement="top" title="" data-original-title="Caso considere backup, o parâmetro irá calcular a necessidade variável contando com as aeronaves backup." aria-describedby="tooltip378065"></i></label>
                <Select
                  className="form-field-name"
                  name="variable_parameter_bkp"
                  value={this.state.variable_parameter_bkp}
                  searchable={true}
                  placeholder={'Selecionar backup'}
                  onChange={this.handleSelectChange.bind(this, 'variable_parameter_bkp')}
                  options={[
                    {value: 0, label: 'Não'},
                    {value: 1, label: 'Sim'},
                  ]}
                />
              </div>
            </div>
            <button type={'submit'} className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Adicionar parametro</button>
          </form>
        </div>
      </div>
      <hr/>
      <table className="table table-stripped table-hover table-bordered">
        <thead>
          <tr>
            <th>Grupo</th>
            <th>Função</th>
            <th>Porte</th>
            <th>Quantidade Fixa</th>
            <th>Quantidade Variável</th>
            <th>Considera anv backup como operacional?</th>
            <th className="col-md-1 text-center"></th>
          </tr>
        </thead>
        <tbody>
        {Object.keys(self.state.params).map(function(kg) {
          var param = self.state.params[kg];
          return (
            <tr>
              <td>{param.group}</td>
              <td>{param.role}</td>
              <td>{param.size}</td>
              <td>{param.quantity_fixed}</td>
              <td>Nº AVN EM OPERAÇÃO x  {param.quantity}</td>
              <td>{param.act_bkp}</td>
              <td>
                <button className="btn btn-sm btn-danger" onClick={() => {self.deleteBaseSettingRoleDelete(self.state.params[kg].id)}}><i className="fa fa-fw fa-trash"></i></button>
              </td>
            </tr>
          );
        })}
        </tbody>
      </table>
    </div>
  </div>
  <hr/>
</div>
    );
  }
}

export default BaseSettings;



// WEBPACK FOOTER //
// ./src/Components/Bases/Elements/BaseSettings.js